import { useCookie } from "#app"

export default defineNuxtRouteMiddleware(async (to) => {
    const token = Array.isArray(to.query.token)
        ? to.query.token[0]
        : to.query.token

    if (token) {
        const sanctumToken = useCookie("sanctum.token.cookie", { secure: true }) // o false en dev
        sanctumToken.value = token

        // Refrescar usuario autenticado
        const { refreshIdentity } = useSanctumAuth()
        try {
            await refreshIdentity()
            const query = { ...to.query }
            delete query.token

            return navigateTo({ path: to.path, query }, { replace: true })
        } catch (error) {
            // Si el error es de autenticación (401), redirige sin lanzar el error
            if ((error as any)?.response?.status === 401) {
                return navigateTo("/auth/login") // Cambia la ruta según lo que necesites
            }
            // Otros errores, si quieres manejarlos diferente
            console.error(error)
        }
    }
})
